/** Valores monetários/taxa das abas TDA, Pedágio e Outros (TMS-8728). */
export const TAX_VALUE_DECIMAL_FIELD_NAMES = [
  "taxa_tda",
  "taxa_tde",
  "vlr_fixo_tda",
  "vlr_fixo_tde",
  "taxa_pedagio",
  "vlr_pedagio",
  "taxa_gris",
  "vlr_minimo_gris",
  "ad_valorem",
  "vlr_minimo_advalorem",
  "vlr_min_nota_cte",
  "vlr_tas",
  "vlr_sec_cat",
  "vlr_despacho",
  "vlr_agendamento",
  "vlr_outros",
  "taxa_devolucao",
  "taxa_reentrega",
  "taxa_coleta",
  "vlr_qtde_docs_fiscais",
];

/** @deprecated use TAX_VALUE_DECIMAL_FIELD_NAMES */
export const OUTROS_TAB_DECIMAL_FIELD_NAMES = TAX_VALUE_DECIMAL_FIELD_NAMES;

/** Campos numéricos da aba Custo extra (mesma precisão de exibição). */
export const CUSTO_EXTRA_DECIMAL_FIELD_NAMES = [
  "vlr_taxa",
  "taxa_comissao",
  "vlr_minimo",
];

export const OUTROS_DECIMAL_SCALE = 3;

function truncateToScale(value, scale) {
  if (!Number.isFinite(value)) {
    return NaN;
  }

  const factor = 10 ** scale;
  const scaled = value * factor;
  const truncated =
    value >= 0 ? Math.floor(scaled + 1e-9) : Math.ceil(scaled - 1e-9);

  return truncated / factor;
}

/**
 * Normaliza texto digitado (BR: vírgula decimal) para número com até 3 casas.
 *
 * @param {string|number|null|undefined} raw
 * @returns {number}
 */
export function parseOutrosDecimal(raw) {
  if (raw === null || raw === undefined) {
    return 0;
  }

  if (typeof raw === "number") {
    return Number.isFinite(raw) ? truncateToScale(raw, OUTROS_DECIMAL_SCALE) : 0;
  }

  let text = String(raw).trim();
  if (!text) {
    return 0;
  }

  text = text.replace(/\s/g, "");

  if (text.includes(",")) {
    text = text.replace(/\./g, "").replace(",", ".");
  }

  const parsed = Number(text);
  if (!Number.isFinite(parsed)) {
    return 0;
  }

  return truncateToScale(parsed, OUTROS_DECIMAL_SCALE);
}

/**
 * Valor numérico pronto para API/estado (até 3 decimais, sem arredondar além da 3ª casa).
 *
 * @param {string|number|null|undefined} value
 * @param {number|null} fallback
 * @returns {number|null}
 */
export function coerceOutrosDecimal(value, fallback = 0) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const parsed = parseOutrosDecimal(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

/**
 * Exibição na aba Outros: sempre 3 casas decimais, separador BR.
 *
 * @param {string|number|null|undefined} value
 * @returns {string}
 */
export function formatOutrosDecimal(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const number = coerceOutrosDecimal(value, NaN);
  if (!Number.isFinite(number)) {
    return "";
  }

  const parts = number.toFixed(OUTROS_DECIMAL_SCALE).split(".");
  const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${integer},${parts[1]}`;
}

/** Detalhe da tabela: R$ + 3 casas (mesma precisão da aba Outros). */
export function formatOutrosMoney(value) {
  const formatted = formatOutrosDecimal(value);
  if (!formatted) {
    return "";
  }

  return `R$ ${formatted}`;
}
